export const LANGUAGE_COOKIE_NAME = "language"
export const COUNTRY_COOKIE_NAME = "country"
export const CURRENCY_COOKIE_NAME = "currency"

export const CURRENT_STORE_COOKIE_NAME = "currentStore"
